





































































import { Component, Prop, Vue } from 'vue-property-decorator';
import Topic from '../../components/topic.vue'
let timer: any;
let mockId = 0;
let favorites: any[] = [];

@Component({ components: { Topic } })
export default class Mock extends Vue {
    @Prop()
    private libraryId !: number;
    @Prop()
    private chapterId !: number;

    private loading = false;


    private testForm = {
        singleNum: 40,
        multipleNum: 40,
        judgeNum: 20,
        singleRange: [1, 1],
        multipleRange: [1, 1],
        judgeRange: [1, 1],
        time: 30,
        isOptionsRandom: false,
        onlyFavorite: false
    }
    private topics = [];
    private singleNum = 0;
    private multipleNum = 0;
    private judgeNum = 0;
    private myAnswers: any[] = [];
    private singleMax = 0;
    private multipleMax = 0;
    private judgeMax = 0;
    private result = {
        usedTime: 0,
        score: 0
    }
    private status = 0;


    get usedTime() {
        let time = this.testForm.time * 60 - this.result.usedTime;
        return this.status == 2 ? `你的得分：${this.result.score}，用时：${Math.floor(this.result.usedTime / 60)}分${this.result.usedTime % 60}秒` : `${Math.floor(time / 60)}分${time % 60}秒`;
    }

    created() {
        this.singleMax = this.$store.state.topic.singleCount;
        this.multipleMax = this.$store.state.topic.multipleCount;
        this.judgeMax = this.$store.state.topic.judgeCount;
        this.testForm.singleRange[1] = this.singleMax;
        this.testForm.multipleRange[1] = this.multipleMax;
        this.testForm.judgeRange[1] = this.judgeMax;
    }

    mounted() {
        // 页面渲染完成
        window.addEventListener('beforeunload', this.beforeunloadFn)
    }

    destroyed() {
        // 页面摧毁
        // 清除定时器
        if (timer) {
            clearInterval(timer);
            timer = 0;
        }

        window.removeEventListener('beforeunload', this.beforeunloadFn)

        // 同步收藏
        this.$apis.postFavorites(this.libraryId, this.chapterId, favorites);
    }

    beforeunloadFn(e: any) {
        // 这个事件只有在鼠标真正和浏览器有了交互，再刷新或者关闭时才会触发, 浏览器事件会弹框确认用户是否要离开页面
        e = e || window.event
        if (this.status == 1 && e) {
            e.returnValue = '关闭提示'
        }
        return '关闭提示'
    }

    onExport() {

    }

    onMyAnswer(index: number, value: string) {
        //this.$set(this.myAnswers, index, value)
        this.myAnswers[index] = value;
        //this.$forceUpdate()
    }

    onMove(index: number) {
        let el = document.getElementById(`topic${index}`);
        if (el) {
            el.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    }

    onBegin() {
        if (this.testForm.singleRange[1] - this.testForm.singleRange[0] + 1 < this.testForm.singleNum) {
            this.$message({
                type: 'success',
                message: '单选题数量超出范围设置'
            });
            return;
        }
        if (this.testForm.multipleRange[1] - this.testForm.multipleRange[0] + 1 < this.testForm.multipleNum) {
            this.$message({
                type: 'success',
                message: '多选题数量超出范围设置'
            });
            return;
        }
        if (this.testForm.judgeRange[1] - this.testForm.judgeRange[0] + 1 < this.testForm.judgeNum) {
            this.$message({
                type: 'success',
                message: '判断题数量超出范围设置'
            });
            return;
        }


        
        this.$apis.postMock(this.libraryId, this.chapterId, this.testForm)
            .then((res: any) => {
                this.singleNum = res.data.singleNum;
                this.multipleNum = res.data.multipleNum;
                this.judgeNum = res.data.judgeNum;
                mockId = res.data.mockId;
                this.topics = res.data.topics;
                this.myAnswers = (new Array(this.topics.length)).fill('');
                this.status = 1;

                // 清除定时器
                if (timer)
                    clearInterval(timer);

                // 启动定时器
                timer = setInterval(() => {
                    if (++this.result.usedTime >= this.testForm.time * 60)
                        this.onFinish();
                }, 1000);
            });
    }

    onFinish() {
        clearInterval(timer);
        timer = 0;
        this.status = 2;
        for (let i = 0; i < this.topics.length; ++i) {
            let res = (this.$refs[`topic${i}`] as any)[0].show(true);
            if (res)
                this.result.score++;
        }
        this.$apis.putMockResult(mockId, this.result); // 上传成绩

        alert(`你的得分：${this.result.score}，用时：${Math.floor(this.result.usedTime / 60)}分${this.result.usedTime % 60}秒`);
    }

    onFav(index: number) {
        let cur : any = this.topics[index];
        cur.isMark = !cur.isMark;

        var res = favorites.find((item, index) => {
            return item.id == cur.id;
        });
        if (res)
            res.isMark = cur.isMark;
        else
            favorites.push({ id: cur.id, isMark: cur.isMark });
    }
}

